import type { Branded } from '@moment/utility-types'

import { z } from 'zod'

/**
 * ISO 8601 calendar date string (e.g. `2026-04-16`).
 *
 * Branded at parse time so plain `string` can't cross the boundary without
 * validation. The schema and the type share one name — import the value to
 * validate, or import it as a type for annotations:
 *
 *   import { IsoDateStr } from '@moment/domain-types'
 *   const day = IsoDateStr.parse(input)   // IsoDateStr
 *
 *   import type { IsoDateStr } from '@moment/domain-types'
 *   function setDate(d: IsoDateStr) { ... }
 *
 * The brand itself is owned by `@moment/utility-types`; zod is used only for
 * the runtime validator. `.transform()` retypes the output so `.parse()`
 * returns our `Branded` type, not `z.BRAND`.
 */
export type IsoDateStr = Branded<string, 'IsoDateStr'>

export const IsoDateStr = z.iso
  .date()
  .transform((v): IsoDateStr => v as IsoDateStr)
